import { render, staticRenderFns } from "./classicCasesDetail.vue?vue&type=template&id=33b9d664&scoped=true"
import script from "./classicCasesDetail.vue?vue&type=script&lang=js"
export * from "./classicCasesDetail.vue?vue&type=script&lang=js"
import style0 from "./classicCasesDetail.vue?vue&type=style&index=0&id=33b9d664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b9d664",
  null
  
)

export default component.exports